var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6293_53254)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2 1.99687C1.64772 1.99687 1.2 2.44459 1.2 2.99687V6.39687H6.4V1.99687H2.2ZM7 0.796875H2.2C0.984974 0.796875 0 1.78185 0 2.99687V6.99687V10.9969C0 12.2119 0.984974 13.1969 2.2 13.1969H7H11.8C13.015 13.1969 14 12.2119 14 10.9969V6.99687V2.99687C14 1.78185 13.015 0.796875 11.8 0.796875H7ZM7.6 1.99687V6.39687H12.8V2.99687C12.8 2.44459 12.3523 1.99687 11.8 1.99687H7.6ZM6.4 7.59687H1.2V10.9969C1.2 11.5492 1.64772 11.9969 2.2 11.9969H6.4V7.59687ZM7.6 11.9969V7.59687H12.8V10.9969C12.8 11.5492 12.3523 11.9969 11.8 11.9969H7.6Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6293_53254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable);
export default __webpack_public_path__ + "static/media/table.f6d8a0dc131d5fbb240279db84dfa3d5.svg";
export { ForwardRef as ReactComponent };